import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Gapper } from '../../../../../ui/utils';
import { colors, fontFamilies } from '../../../../../constants/theme';
import { figmaLetterSpacing } from '../../../../../ui/utils';
import { SectionHeading } from '../../../../../ui/typography';

export const Wrapper = styled(Gapper)(({ theme }) => ({
  alignItems: 'center',
  maxWidth: 900,
  margin: '0 auto',
  gap: 20,
  [theme.breakpoints.down('md')]: {
    padding: '0 20px',
    gap: 16,
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
    gap: 14,
  },
}));

export const Paper = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: 10,
  borderRadius: 40,
  backgroundColor: colors.whiteText,
  boxShadow:
    ' -4px -4px 17.8px 0px rgba(205, 214, 223, 0.15), 4px 4px 15px 0px rgba(205, 214, 223, 0.25)',
  [theme.breakpoints.down('md')]: {
    padding: 8,
    borderRadius: 24,
  },
  [theme.breakpoints.down('sm')]: {
    padding: 6,
    borderRadius: 16,
  },
}));

export const Content = styled(Gapper)(({ theme }) => ({
  alignItems: 'center',
  gap: 30,
  backgroundColor: colors.iconBackground,
  padding: 50,
  borderRadius: 32,
  [theme.breakpoints.down('md')]: {
    gap: 24,
    padding: 30,
    borderRadius: 20,
  },
  [theme.breakpoints.down('sm')]: {
    gap: 20,
    padding: 24,
    borderRadius: 16,
  },
}));

export const Title = styled(SectionHeading)(({ theme }) => ({
  fontFamily: fontFamilies.gothamBook,
  fontWeight: 400,
  fontSize: '40px',
  lineHeight: '58px',
  letterSpacing: figmaLetterSpacing(40, -1),
  color: theme.palette.text.primary,
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: '32px',
    lineHeight: '40px',
    letterSpacing: figmaLetterSpacing(32, -1),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '26px',
    lineHeight: '34px',
    letterSpacing: figmaLetterSpacing(26, -1),
    textAlign: 'center',
  },
}));

export const Text = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,
  fontSize: '22px',
  lineHeight: 1.27,
  letterSpacing: figmaLetterSpacing(22, 3),
  color: theme.palette.text.primary,
  textAlign: 'center',
  maxWidth: 620,
  [theme.breakpoints.down('lg')]: {
    fontSize: '20px',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
  },
}));

export const FormSection = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: 10,
});
